<template>
  <div class="container">
    <top-menu :current="['car']"></top-menu>

    <div class="main-container">
      <h4 class="idx-title-nav">热门特卖车型</h4>
      <div class="dealer-filter">
        <div class="cate">
          <a-dropdown style="text-align: center">
            <a class="ant-dropdown-link">
              {{ selected.level_name }} <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item
                :key="level.id"
                v-for="level in levels"
                @click="changeLevel(level)"
              >
                {{ level.name }}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div class="cate">
          <a-dropdown style="text-align: center">
            <a class="ant-dropdown-link">
              {{ selected.price_name }} <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item
                :key="price.id"
                v-for="price in prices"
                @click="changePrice(price)"
              >
                {{ price.name }}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div class="cate">
          <a-dropdown style="text-align: center">
            <a class="ant-dropdown-link" @click="showBrands()">
              {{ selected.brand_name }} <a-icon type="down" />
            </a>
          </a-dropdown>
        </div>
      </div>
      <a-skeleton
        :loading="carLoading"
        active
        :paragraph="{ rows: 15 }"
        :title="false"
      >
        <div class="cars">
          <div
            class="cpt-series-card-4"
            v-for="item in results"
            v-bind:key="item.id"
          >
            <div class="series-img-wrap">
              <img class="series-img" :src="item.cover_url" />
            </div>
            <div class="series-info">
              <p class="series-name">
                <span class="series-name-inner">{{ item.name }}</span>
              </p>
              <div class="style-container-0">
                <p class="series-price force-black-1">
                  指导价：{{ item.price }}
                </p>
              </div>
            </div>
            <router-link :to="{ name: 'Series', params: { id: item.id } }">
              <button class="dealer-btn">详情</button>
            </router-link>
          </div>
          <NoData
            text="该条件暂无车型数据，换个条件试试吧 ∼"
            v-if="results.length == 0"
          />
          <div
            class="data-more"
            style="text-align: center; margin: 10px 0 15px"
            @click="more"
            v-if="!is_end"
          >
            加载更多
          </div>
          <div
            class="data-more"
            style="text-align: center; margin: 10px 0 15px"
            v-if="is_end"
          >
            数据已全部加载
          </div>
        </div>
      </a-skeleton>
    </div>

    <a-drawer
      title="选择品牌"
      placement="right"
      :closable="true"
      :visible="brandVisible"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
      :bodyStyle="{ padding: 0 }"
    >
      <div class="quote-brand-card" v-for="item in brands" :key="item.letter">
        <div class="quote-brand-card__letter">{{ item.letter }}</div>
        <ul>
          <li
            v-for="ite in item.brands"
            :key="ite.id"
            @click="chooseBrand(ite)"
          >
            <img :src="ite.logo_url" />
            <span> {{ ite.name }}</span>
          </li>
        </ul>
      </div>
    </a-drawer>

    <Footer />
  </div>
</template>

<script>
import TopMenu from "@/components/Menu";
import Footer from "@/components/Footer";
import { getSearchCars } from "@/api/car";
import brandData from "@/data/brand";
import NoData from "@/components/NoData";

import CarsData from "@/data/cars";

export default {
  name: "Index",
  components: {
    TopMenu,
    Footer,
    NoData,
  },
  data() {
    return {
      page: 1,
      limit: 20,
      brandVisible: false,
      brands: [],
      carLoading: true,
      selected: {
        brand_name: "品牌",
        brand_id: 0,
        level_name: "级别",
        level_id: "",
        price_name: "价格",
        price_id: 0,
        price_min: 0,
        price_max: 0,
      },
      levels: CarsData.levels,
      prices: CarsData.prices,
      results: [],
      total: 0,
      is_end: false,
    };
  },
  computed: {},
  beforeCreadted() {},
  created() {
    this.initData();
    this.getData();
  },
  beforeDestroy() {},
  methods: {
    getData() {
      let formData = {
        page: this.page,
        limit: this.limit,
        levels: this.selected.level_id,
        min_price: this.selected.price_min,
        max_price: this.selected.price_max,
        bid: this.selected.brandId,
      };
      getSearchCars(formData).then((response) => {
        if (response.data.length < this.limit) {
          this.is_end = true;
        }

        var that = this;

        response.data.list.forEach((resp) => {
          that.results.push(resp);
        });

        this.total = response.data.count;
        this.carLoading = false;
      });
    },
    initData() {
      let letters = []; // 数据列表
      let brandMap = {}; // 每一个索引指向一个数组，这个数组存储该字母索引的朋友项

      brandData.forEach((brand) => {
        const letter = brand.letter;
        brandMap[letter] || (brandMap[letter] = []);
        brandMap[letter].push(brand);
      });

      for (let letter in brandMap) {
        letters.push({
          letter: letter,
          brands: brandMap[letter],
        });
      }

      // 按首字母排序
      // 字符串比较不能用减号得出大小，返回都是NaN
      // 因此这里需要通过小于号比较
      letters.sort((a, b) => {
        return a.letter <= b.letter ? -1 : 1;
      });

      this.brands = letters;
    },
    onClose() {
      this.brandVisible = false;
    },
    showBrands() {
      this.brandVisible = true;
    },
    afterVisibleChange() {},
    chooseBrand(brand) {
      this.brandVisible = false;
      this.selected.brand_id = brand.id;
      this.selected.brand_name = brand.name;
      this.getData();
    },
    getCityId() {
      let curCity = localStorage.getItem("_m_cur_city");

      if (curCity) {
        console.log(">>>", curCity);
        let curCityData = JSON.parse(curCity);

        return curCityData.c_id;
      }

      return 110100;
    },

    more() {
      this.page = this.page + 1;
      this.getData();
    },

    changeLevel(level) {
      this.selected.level_id = level.id;
      this.selected.level_name = level.name;
      this.resetPage();
      this.getData();
    },

    changePrice(price) {
      this.selected.price_name = price.name;
      this.selected.price_id = price.id;
      this.selected.price_max = price.max;
      this.selected.price_min = price.min;
      this.resetPage();
      this.getData();
    },

    resetPage() {
      this.page = 1;
      this.cars = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 800px;
  // overflow: hidden;
  margin: 0 auto;
}
.main-container {
  // margin: 0.8rem;
   position: relative;
  top:100px;
  .idx-title-nav {
    margin: 10px 15px;
  }
  .data-more {
    text-align: center;
    margin: 10px 0 15px;
  }
}

.quote-brand-card {
  .quote-brand-card__letter {
    position: relative;
    height: 1.5rem;
    margin: 0;
    padding: 0 0 0 0.5rem;
    font-size: 0.65rem;
    color: #333;
    line-height: 1.5rem;
    background-color: #f8f8f8;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    overflow: hidden;
    li {
      position: relative;
      padding: 0.25rem 0 0.25rem 0.5rem;
      img {
        float: left;
        width: 2.5rem;
        height: 2.5rem;
        margin: 0;
      }
      & > span {
        position: relative;
        display: block;
        height: 2.5rem;
        padding: 0;
        margin: 0 0 0 3.5rem;
        font-size: 0.8rem;
        color: #333;
        line-height: 2.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.dealer-filter {
  width: 100%;
  height: 38px;
  background-color: #fff;
  margin: 10px 0px 0;
  display: flex;
  line-height: 38px;
  border-bottom: 1px solid #eff3f8;
  .cate {
    display: flex;
    background: #fff;
    flex: 1;
    border-right: 1px solid #eff3f8;
    cursor: pointer;
    justify-content: center;

    a {
      color: #333;
    }

    & > div {
      font-size: 14px;
      font-weight: 700;
      color: #616b84;
      line-height: 20px;
      padding: 10px 0;

      width: 100%;
      text-align: center;
    }
    .pl-sub-cate {
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: 700;
      color: #616b84;
      cursor: pointer;
    }
  }
  .cate__selected {
    background-color: #fe815f;
    color: #fff !important;
  }
}

.cars {
  .cpt-series-card-4 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    background: #fff;
    .series-img-wrap {
      position: relative;
      .series-img {
        width: 100px;
        margin: 12px 15px;
      }
    }
    .series-info {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -ms-flex: 1;
      flex: 1;
      min-width: 0;
      width: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: 100px;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      .series-name {
        font-size: 16px;
        line-height: 22px;
        padding-right: 10px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        margin-bottom: 5px;
        .series-name-inner {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          word-break: break-all;
        }
      }
      .series-price {
        font-size: 12px;
        line-height: 20px;
        margin-top: 10px;
        color: rgb(243, 62, 62);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .dealer-btn {
      border: none;
      border-radius: 4px;
      font-size: 14px;
      line-height: 20px;
      padding: 4px 8px;
      margin-right: 15px;
      color: #fff;
      background-color: #ff4b3c;
      outline: 0;
    }
  }
}
.flexBC {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>

